import type { Meta, StoryFn } from '@storybook/react';

import { AdditionalInfo, Flex } from '@pega/cosmos-react-core';
import type { AdditionalInfoProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/AdditionalInfo',
  component: AdditionalInfo
} as Meta;

type AdditionalInfoStoryProps = AdditionalInfoProps & {
  configurableContent: string;
};

export const AdditionalInfoDemo: StoryFn<AdditionalInfoStoryProps> = (
  args: AdditionalInfoStoryProps
) => {
  return (
    <AdditionalInfo heading='Additional info'>
      <Flex container={{ justify: 'between' }}>
        <p>
          {args.configurableContent}
          <a href='https://www.pega.com' target='_blank' rel='noreferrer'>
            This is a link
          </a>
        </p>
        <img
          src='https://www.pyze.com/wp-content/uploads/2020/07/pega-transparent-logo-2.png'
          style={{ width: 150 }}
          alt=''
        />
      </Flex>
    </AdditionalInfo>
  );
};

AdditionalInfoDemo.args = {
  configurableContent: 'This content can be modified to fit the necessary additional info. '
};

AdditionalInfoDemo.argTypes = {
  configurableContent: { control: { type: 'text' } }
};
